export default {
  ERROR: {
    MSG_1:
      'Your sign-in attempt was not successful, please try again. Invalid username or password',
    MSG_2: `You have been locked out due to too many failed sign-in attempts.
    Please enter your username then click on the “Locked Out?” Link below.`,
    MSG_3:
      'You must enter your username prior to clicking on the “Forgot Password? Locked Out?” link.',
    MSG_4: `This user does not have any active accounts.
    There must be at least one active account to sign into OneView.`,
    MSG_5:
      'You are signing in using a temporary password. You must change your password now.',
    MSG_6: 'The passwords do not match.',
    MSG_7: 'The password does not meet requirements.',
    MSG_8: 'The Answer field is blank.',
    MSG_9: `This username is not valid or does not have any active accounts.
    Please contact your Simmons representative.`,
    MSG_10: `This username does not have a challenge question set up.
    Please contact your Simmons representative.`,
    MSG_11: 'The challenge question was not answered correctly.',
    MSG_12:
      'You must enter your username and password prior to clicking "Sign In" button.',
    MSF_13: 'Password previously used. Please create a new password.',
  },
  INFO: {
    MSG_1: `Passwords must be at least 8 characters in length and contain at least one or more upper case letters,
 one or more lower case letters, and one or more numbers`,
    MSG_2: `A temporary password has been emailed to this user.
    If the account was locked, it has also been unlocked.`,
  },
};
